/**
 * Kampanj på avvikelserapporten.
 *
 * September 2026: rapporten är kostnadsfri för alla föreningar (Gabriels
 * mejl 2026-09-09). Datumen ligger här, inte i vyerna, så att priset kommer
 * tillbaka av sig självt den 1 oktober utan en ny driftsättning. En ny
 * kampanj är ett byte av datum och text på ett ställe.
 *
 * Priset räknas i svensk tid: kampanjen tar slut vid midnatt i Stockholm,
 * inte vid midnatt UTC.
 */

export const AUDIT_REPORT_FEES = {
  base: 795,
  perApartment: 2.5,
} as const;

export const AUDIT_REPORT_CAMPAIGN = {
  id: 'gratis-september-2026',
  startsOn: '2026-09-01',
  endsOn: '2026-09-30',
  title: 'Septemberkampanj – kostnadsfri avvikelserapport',
  text: 'Under september erbjuder vi er möjligheten att beställa en avvikelserapport helt kostnadsfritt.',
  validUntil: 'Erbjudandet gäller till och med den 30 september 2026.',
  navLabel: 'Gratis',
} as const;

const TZ = 'Europe/Stockholm';

/** Dagens datum i svensk tid, ÅÅÅÅ-MM-DD. */
export function todayInStockholm(now: Date = new Date()): string {
  return now.toLocaleDateString('sv-SE', { timeZone: TZ });
}

export function isAuditCampaignActive(today: string = todayInStockholm()): boolean {
  return today >= AUDIT_REPORT_CAMPAIGN.startsOn && today <= AUDIT_REPORT_CAMPAIGN.endsOn;
}

export interface AuditReportPrice {
  free: boolean;
  base: number;
  variable: number;
  total: number;
  /** Satt när beställningen görs under en kampanj — sparas på beställningen. */
  campaignId: string | null;
}

/** Vad en beställning kostar i dag, för ett givet antal lägenheter. */
export function auditReportPrice(apartmentCount: number, today?: string): AuditReportPrice {
  const free = isAuditCampaignActive(today);
  const base = free ? 0 : AUDIT_REPORT_FEES.base;
  const variable = free ? 0 : apartmentCount * AUDIT_REPORT_FEES.perApartment;
  return { free, base, variable, total: base + variable, campaignId: free ? AUDIT_REPORT_CAMPAIGN.id : null };
}

/** Gjordes beställningen under en kampanj? Flaggan skrivs av klienten vid beställning. */
export function isCampaignOrder(order: { campaignId?: unknown } | null | undefined): boolean {
  return !!order && typeof order.campaignId === 'string' && order.campaignId.length > 0;
}
